module.exports = __webpack_public_path__ + "4a5710e786065993ed6ca4fa186dec03.jpg";